'use client';
import { createPalette } from './createPalette/createPalette.js';
import { DEFAULT_COLOR_INVARIANTS } from '../invariants/defaultInvariants.js';
import { DEFAULT_COLORS } from '../colors/defaultColors.js';

const DEFAULT_PALETTE = createPalette(DEFAULT_COLORS, DEFAULT_COLOR_INVARIANTS);

export { DEFAULT_PALETTE };
//# sourceMappingURL=defaultPalette.js.map
